import { render, staticRenderFns } from "./FilterSearch.vue?vue&type=template&id=4a97a36c"
import script from "./FilterSearch.vue?vue&type=script&lang=js"
export * from "./FilterSearch.vue?vue&type=script&lang=js"
import style0 from "./FilterSearch.vue?vue&type=style&index=0&id=4a97a36c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports